module.exports = __webpack_public_path__ + "img/dark-medium-home.7a8234f6.svg";